import React, { Component } from 'react';
import StoryMixerTermView from './StoryMixerTermView';
import PropTypes from 'prop-types';
import './storyMixerGroup.less';
import StoryMixerCategoryView from './StoryMixerCategoryView';

class StoryMixerGroup extends Component {

	constructor(props) {
		super(props);

		this.state = {
			width: props.width
		};

	}
	renderStoryMixerTerms() {
		const { storyMixerTerms, setHoveredTerm, categoryName, ...propsToPass } = this.props;

		storyMixerTerms.sort(function (a, b) {
			return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
		});

		const termList = storyMixerTerms.map((term, index) => {
			return (
				<StoryMixerTermView
					key={index}
					storyMixerTermData={term}
					setHoveredTerm={setHoveredTerm}
					{...propsToPass}
				/>
			);
		});

		return termList;
	}
	render() {
		let groupClass = '';
		let termsClass = '';

		if (this.props.width > 450) {
			groupClass = 'story-mixer-group';
			termsClass = 'flex-row';
		}
		else {
			groupClass = 'story-mixer-group-small';
			termsClass = 'flex-column';
		}

		return (
			<div ref={this.props.measureRef} className={groupClass} >
				<div className='padded-bottom'>
					<StoryMixerCategoryView category={this.props.categoryName} />
				</div>
				<div className={termsClass}>
					{this.renderStoryMixerTerms()}
				</div>
			</div>
		);
	}
}

StoryMixerGroup.propTypes = {
	storyMixerTerms: PropTypes.array.isRequired,
	setHoveredTerm: PropTypes.func.isRequired,
	categoryName: PropTypes.string.isRequired,
}

export default StoryMixerGroup;





// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerGroup.jsx